import { Link, Typography, type TypographyProps, styled } from '@lingoda/ui';
import { getUrlLang } from '@lingoda/env';
import { FormattedMessage, trans } from '@lingoda/i18n';
import { useToggleState } from '@lingoda/hooks';
import { PrivacyDialog, TermsDialog } from '../dialogs';

type TermsAndPrivacyProps = Pick<TypographyProps, 'sx' | 'typography'>;

export const TermsAndPrivacy = (props: TermsAndPrivacyProps) => {
    const [openPrivacy, handleOpenPrivacy, handleClosePrivacy] = useToggleState(false);
    const [openTerms, handleOpenTerms, handleCloseTerms] = useToggleState(false);

    const imprintPath = `https://www.lingoda.com/${getUrlLang(window.location.href)}/imprint/`;

    return (
        <ContainerStyled variant="body1" sx={props.sx} typography={props.typography}>
            <FormattedMessage
                message={trans('form-label-signup-terms-and-conditions', {}, 'public-common')}
                values={{
                    termsLink: (chunks) => (
                        <Link onClick={handleOpenTerms} data-cy="termsLink">
                            {chunks}
                        </Link>
                    ),
                    privacyLink: (chunks) => (
                        <Link onClick={handleOpenPrivacy} data-cy="privacyLink">
                            {chunks}
                        </Link>
                    ),
                    imprintLink: (chunks) => (
                        <Link to={imprintPath} target="_blank" data-cy="imprintLink">
                            {chunks}
                        </Link>
                    ),
                }}
            />
            <TermsDialog isOpen={openTerms} onClose={handleCloseTerms} />
            <PrivacyDialog isOpen={openPrivacy} onClose={handleClosePrivacy} />
        </ContainerStyled>
    );
};

const ContainerStyled = styled(Typography)(() => {
    return {
        a: {
            cursor: 'pointer',
        },
    };
});
